(ns common.schema.entities.workspace.kyc.templates.lifeline.smo
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(def schema
  {:kyc-template/template-name
   "SMO"
   :kyc-template/kyc-form-preface
   {:translations {:en "Senior Managing Officers (SMO)"
                   :fi "Johtavat toimihenkilöt"}}

   :kyc-smo.group/basic-information
   {:ord          1.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-smo/first-name]
                    [:kyc-smo/last-name]
                    [:kyc-smo/dob]
                    [:kyc-smo/pob]
                    [:kyc-smo/cob]
                    [:kyc-smo/nationality]
                    [:kyc-smo/country]
                    [:kyc-smo/management-position]
                    [:kyc-smo/management-position-other]])}

   :kyc-smo.group/tax-residencies
   {:ord          2.0
    :translations {:en "Tax Residency"
                   :fi "Verovelvollisuus"}
    :info         {:en ""
                   :fi "Lisää myös valtiot, joihin henkilö maksaa tulo- tai kiinteistöveroa"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-smo/tax-countries]
                    [:kyc-smo/usa-tax-residence]
                    [:kyc-smo/non-usa-confirmation]
                    [:kyc-smo/usa-confirmation]])}

   :kyc-smo.group/pep
   {:ord          3.0
    :translations {:en "Politically exposed person"
                   :fi "Poliittinen vaikutusvalta"}
    :info         {:en (str "<p>A person is considered a PEP, who is in a prominent public function or an immediate family "
                            "member or a close associate of such a person either in Finland or another country?</p>")
                   :fi (str "<p>Henkilö on poliittisesti vaikutusvaltainen, jos hän tai hänen lähipiiriinsä kuuluva henkilö "
                            "toimii tai on toiminut merkittävässä julkisessa virassa Suomessa tai toisessa valtiossa.</p>")}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-smo/pep]
                    [:kyc-smo.pep/country]
                    [:kyc-smo.pep/political-function]
                    [:kyc-smo.pep/relationship-to-smo]
                    [:kyc-smo.pep/name]])}})
